module.exports = __webpack_public_path__ + "img/w3_circle_right_grey.1a56595d.png";